const PICKER_FILESTACK_API_KEY = "Ab4UxJ7gSSG4hnZD7BeIHz";

export function resolveFilestackApiKey(explicit) {
  return String(explicit || "").trim() || PICKER_FILESTACK_API_KEY;
}
